// request-url.token.ts
import { InjectionToken } from '@angular/core';

export const REQUEST_URL = new InjectionToken<string>('REQUEST_URL');